import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { ICON_SIZE, ICON_TYPE, withIcon } from "components/Icon";
import PrimaryLink from "./Primary";

/**
 * FileLinks
 *
 * One row per file, opening in a new tab. A file without a url is shown as plain text.
 *
 * @param {Array} files   [{ id, value, url }]
 */
const FileLinks = ({ files = [], ...props }) => (
  <ul css={styles.list} {...props}>
    {files.map(({ id, value, url }) => (
      <li key={id || value} css={styles.item}>
        {url ? (
          <FileLink to={url} target="_blank">
            {value}
          </FileLink>
        ) : (
          value
        )}
      </li>
    ))}
  </ul>
);

const FileLink = withIcon(PrimaryLink, {
  type: ICON_TYPE.file,
  size: ICON_SIZE.large,
  color: "inherit",
});

const styles = {
  list: css`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
  `,
  item: css`
    display: flex;
    align-items: center;
  `,
};

FileLinks.propTypes = {
  files: PropTypes.array,
};

export default FileLinks;
